<p-card class="w-full p-2 m-4 md:w-6/12">
  <ng-template #title> Account Information </ng-template>
  <ul class="p-0 m-0 list-none border-top-1 surface-border">
    <li class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-semibold text-primary-300 md:w-2/12">Name</div>
      <div class="w-8/12 md:w-10/12 md:flex-order-0 flex-order-1 text-400">
        {{ customer_overview()?.name }}
      </div>
    </li>
    <li class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-semibold text-primary-300 md:w-2/12">Address</div>
      <div class="w-8/12 text-400 md:w-10/12">
        {{getCustomerAddress()}}
      </div>
    </li>
    <li class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-semibold text-primary-300 md:w-2/12">
        Email Address
      </div>
      <div class="w-8/12 text-400 md:w-10/12">
        {{ customer_overview()?.email }}
      </div>
    </li>
    <li class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-semibold text-primary-300 md:w-2/12">
        Phone Number
      </div>
      <div class="w-8/12 text-400 md:w-10/12">
        {{ customer_overview()?.mobile_phone}}
      </div>
    </li>
  </ul>
</p-card>